import { QueryHookOptions } from '@apollo/client';

import { PaginationInfo, usePaginatedQuery } from '@occc-app/hooks/usePaginatedQuery';
import {
  KioskFilter,
  useKiosksQuery,
  KiosksQuery,
  KiosksQueryVariables,
  KioskFragment,
} from '@occc/graphql';

type GetKiosksProps = {
  filter: KioskFilter;
  pageSize?: number;
  baseOptions?: QueryHookOptions<KiosksQuery, KiosksQueryVariables>;
  paginationInfo?: PaginationInfo;
  onPageChange?: (info: PaginationInfo) => void;
};

export const transformDataToKiosksArray = (data?: KiosksQuery): KioskFragment[] | undefined =>
  data?.kiosks?.edges?.map((e) => e.node);

export const useGetKiosks = ({
  filter,
  pageSize,
  baseOptions,
  paginationInfo,
  onPageChange,
}: GetKiosksProps) => {
  const response = usePaginatedQuery(
    useKiosksQuery,
    'kiosks.pageInfo',
    pageSize,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      variables: {
        filter,
      },
      ...baseOptions,
    } as QueryHookOptions<KiosksQuery, KiosksQueryVariables>,
    paginationInfo,
    onPageChange,
  );

  return {
    ...response,
    data: transformDataToKiosksArray(response.data),
  };
};
